import styled from 'styled-components'
import { Button } from '@navent-jobs/ui-kit/components/button'

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 12px;
  justify-content: center;
`

export const CustomButton = styled(Button)<{ theme }>`
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: ${props => props.theme.screen.mdMin}) {
    margin: 0px 12px;
    max-width: 200px;
  }
`

export const ButtonContent = styled.div<{ theme }>`
  display: flex;
  flex-direction: column-reverse;
  justify-content: center;
  padding: 0px 16px;
  margin-top: 32px;
  @media (min-width: ${props => props.theme.screen.mdMin}) {
    padding: 0px 24px;
    flex-direction: row;
  }
`
export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const DeleteImage = styled.img<{ theme }>`
  align-self: center;
  width: 120px;
  margin-bottom: 24px;
  @media (min-width: ${props => props.theme.screen.mdMin}) {
    margin-bottom: 32px;
  }
`
